import React, {useCallback, useContext} from 'react';

import Link from '~/src/components/link/Link';

import {LoginContext} from '~/src/components/context/LoginContext';
import {UserProfileContext} from '~/src/components/context/UserProfileContext';
import {login} from '~/src/utilities/helpers/account';
import {getPageUrl} from '~/src/utilities/helpers/link';
import initPolyglot from '~/src/utilities/libs/polyglot';

import i18nStrings from './UserProfileButton.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

interface UserProfileButtonProps {
    className: string;
    children?: React.ReactNode;
    onProfile?: () => void;
    onLogin?: () => void;
}

const UserProfileButton = ({className, children, onLogin, onProfile}: UserProfileButtonProps) => {
    const {isReady, isLoggedIn} = useContext(LoginContext);
    const {data: profileData, isLoaded} = useContext(UserProfileContext);

    const onLoginClick = useCallback(() => {
        onLogin && onLogin();
        login();
    }, [onLogin]);

    if (!isReady || !isLoaded) {
        return null;
    }

    return isLoggedIn ? (
        <Link href={getPageUrl('profile')} className={className} onClick={onProfile} title={profileData?.nickname || getTranslation('profile')}>
            {children}
            <span>{profileData?.nickname || getTranslation('profile')}</span>
        </Link>
    ) : (
        <Link onClick={onLoginClick} className={className}>
            {children}
            {getTranslation('login')}
        </Link>
    );
};

export default UserProfileButton;
